const optionsPartido = [    
    { "value": "001", "seccion_electoral": "Sexta Sección", "label": "Adolfo Alsina", "region": "INTERIOR - 50 MIL HAB." },//6007
    { "value": "051", "seccion_electoral": "Sexta Sección", "label": "Adolfo Gonzales Chaves", "region": "INTERIOR - 50 MIL HAB." },//6014
    { "value": "002", "seccion_electoral": "Cuarta Sección", "label": "Alberti", "region": "INTERIOR - 50 MIL HAB." },//6021
    { "value": "003", "seccion_electoral": "Tercera Sección", "label": "Almirante Brown", "region": "RMBA" },//6028
    { "value": "010", "seccion_electoral": "Segunda Sección", "label": "Arrecifes", "region": "INTERIOR - 50 MIL HAB." },//6077
    { "value": "004", "seccion_electoral": "Tercera Sección", "label": "Avellaneda", "region": "RMBA" },//6035
    { "value": "005", "seccion_electoral": "Quinta Seccion", "label": "Ayacucho", "region": "INTERIOR - 50 MIL HAB." },//6042
    { "value": "006", "seccion_electoral": "Séptima Sección", "label": "Azul", "region": "INTERIOR + 50 MIL HAB." },//6049
    { "value": "007", "seccion_electoral": "Sexta Sección", "label": "Bahía Blanca", "region": "INTERIOR + 50 MIL HAB." },//6056
    { "value": "008", "seccion_electoral": "Quinta Seccion", "label": "Balcarce", "region": "INTERIOR + 50 MIL HAB." },//6063
    { "value": "009", "seccion_electoral": "Segunda Sección", "label": "Baradero", "region": "INTERIOR - 50 MIL HAB." },//6070
    { "value": "053", "seccion_electoral": "Sexta Sección", "label": "Benito Juárez", "region": "INTERIOR - 50 MIL HAB." },//6084
    { "value": "120", "seccion_electoral": "Tercera Sección", "label": "Berazategui", "region": "RMBA" },//6091
    { "value": "114", "seccion_electoral": "Tercera Sección", "label": "Berisso", "region": "RMBA" },//6098
    { "value": "011", "seccion_electoral": "Séptima Sección", "label": "Bolívar", "region": "INTERIOR - 50 MIL HAB." },//6105
    { "value": "012", "seccion_electoral": "Cuarta Sección", "label": "Bragado", "region": "INTERIOR - 50 MIL HAB." },//6112
    { "value": "013", "seccion_electoral": "Tercera Sección", "label": "Brandsen", "region": "RMBA" },//6119
    { "value": "014", "seccion_electoral": "Primera Sección", "label": "Campana", "region": "RMBA" },//6126
    { "value": "015", "seccion_electoral": "Tercera Sección", "label": "Cañuelas", "region": "RMBA" },//6134
    { "value": "121", "seccion_electoral": "Segunda Sección", "label": "Capitán Sarmiento", "region": "INTERIOR - 50 MIL HAB." },//6140
    { "value": "016", "seccion_electoral": "Cuarta Sección", "label": "Carlos Casares", "region": "INTERIOR - 50 MIL HAB." },//6147
    { "value": "017", "seccion_electoral": "Cuarta Sección", "label": "Carlos Tejedor", "region": "INTERIOR - 50 MIL HAB." },//6154
    { "value": "018", "seccion_electoral": "Segunda Sección", "label": "Carmen de Areco", "region": "INTERIOR - 50 MIL HAB." },//6161
    { "value": "020", "seccion_electoral": "Quinta Seccion", "label": "Castelli", "region": "INTERIOR - 50 MIL HAB." },//6168
    { "value": "026", "seccion_electoral": "Cuarta Sección", "label": "Chacabuco", "region": "INTERIOR + 50 MIL HAB." },//6210
    { "value": "027", "seccion_electoral": "Quinta Seccion", "label": "Chascomús", "region": "INTERIOR - 50 MIL HAB." },//6218
    { "value": "028", "seccion_electoral": "Cuarta Sección", "label": "Chivilcoy", "region": "INTERIOR + 50 MIL HAB." },//6224
    { "value": "021", "seccion_electoral": "Segunda Sección", "label": "Colón", "region": "INTERIOR - 50 MIL HAB." },//6175
    { "value": "113", "seccion_electoral": "Sexta Sección", "label": "Coronel Rosales", "region": "INTERIOR + 50 MIL HAB." },//6182 Coronel de Marina Leonardo Rosales
    { "value": "022", "seccion_electoral": "Sexta Sección", "label": "Coronel Dorrego", "region": "INTERIOR - 50 MIL HAB." },//6189
    { "value": "023", "seccion_electoral": "Sexta Sección", "label": "Coronel Pringles", "region": "INTERIOR - 50 MIL HAB." },//6196
    { "value": "024", "seccion_electoral": "Sexta Sección", "label": "Coronel Suárez", "region": "INTERIOR - 50 MIL HAB." },//6203
    { "value": "019", "seccion_electoral": "Sexta Sección", "label": "Daireaux", "region": "INTERIOR - 50 MIL HAB." },//6231
    { "value": "029", "seccion_electoral": "Quinta Seccion", "label": "Dolores", "region": "INTERIOR - 50 MIL HAB." },//6238    

    { "value": "115", "seccion_electoral": "Tercera Sección", "label": "Ensenada", "region": "RMBA" },//6245
    { "value": "118", "seccion_electoral": "Primera Sección", "label": "Escobar", "region": "RMBA" },//6252
    { "value": "030", "seccion_electoral": "Tercera Sección", "label": "Esteban Echeverría", "region": "RMBA" },//6260
    { "value": "031", "seccion_electoral": "Segunda Sección", "label": "Exaltación de la Cruz", "region": "RMBA" },//6266
    { "value": "130", "seccion_electoral": "Tercera Sección", "label": "Ezeiza", "region": "RMBA" },//6270
    { "value": "032", "seccion_electoral": "Tercera Sección", "label": "Florencio Varela", "region": "RMBA" },//6274
    { "value": "128", "seccion_electoral": "Cuarta Sección", "label": "Florentino Ameghino", "region": "INTERIOR - 50 MIL HAB." },//6277
    { "value": "033", "seccion_electoral": "Quinta Seccion", "label": "General Alvarado", "region": "INTERIOR - 50 MIL HAB." },//6280
    { "value": "034", "seccion_electoral": "Séptima Sección", "label": "General Alvear", "region": "INTERIOR - 50 MIL HAB." },//6287
    { "value": "035", "seccion_electoral": "Cuarta Sección", "label": "General Arenales", "region": "INTERIOR - 50 MIL HAB." },//6294
    
    { "value": "036", "seccion_electoral": "Quinta Seccion", "label": "General Belgrano", "region": "INTERIOR - 50 MIL HAB." },//6301
    { "value": "037", "seccion_electoral": "Quinta Seccion", "label": "General Guido", "region": "INTERIOR - 50 MIL HAB." },//6308
    //38 es ZARARTE ---esta abajo en la lista
    { "value": "039", "seccion_electoral": "Quinta Seccion", "label": "General Madariaga", "region": "INTERIOR - 50 MIL HAB." },//6315
    { "value": "040", "seccion_electoral": "Sexta Sección", "label": "General La Madrid", "region": "INTERIOR - 50 MIL HAB." },//6322
    { "value": "041", "seccion_electoral": "Primera Sección", "label": "General Las Heras", "region": "RMBA" },//6329
    { "value": "042", "seccion_electoral": "Quinta Seccion", "label": "General Lavalle", "region": "INTERIOR - 50 MIL HAB." },//6336
    { "value": "043", "seccion_electoral": "Quinta Seccion", "label": "General Paz", "region": "INTERIOR - 50 MIL HAB." },//6343
    { "value": "044", "seccion_electoral": "Cuarta Sección", "label": "General Pinto", "region": "INTERIOR - 50 MIL HAB." },//6351
    { "value": "045", "seccion_electoral": "Quinta Seccion", "label": "General Pueyrredón", "region": "INTERIOR + 50 MIL HAB." },//6357
    { "value": "046", "seccion_electoral": "Primera Sección", "label": "General Rodríguez", "region": "RMBA" },//6364

    { "value": "047", "seccion_electoral": "Primera Sección", "label": "General San Martín", "region": "RMBA" },//6371//tenia 46
    //NO HAY 48
    { "value": "049", "seccion_electoral": "Cuarta Sección", "label": "General Viamonte", "region": "INTERIOR - 50 MIL HAB." },//6385//tenia48
    { "value": "050", "seccion_electoral": "Cuarta Sección", "label": "General Villegas", "region": "INTERIOR - 50 MIL HAB." },//6392
    { "value": "052", "seccion_electoral": "Sexta Sección", "label": "Guaminí", "region": "INTERIOR - 50 MIL HAB." },//6399
    { "value": "119", "seccion_electoral": "Cuarta Sección", "label": "Hipólito Yrigoyen", "region": "INTERIOR - 50 MIL HAB." },//6406
    { "value": "135", "seccion_electoral": "Primera Sección", "label": "Hurlingham", "region": "RMBA" },//6408
    { "value": "136", "seccion_electoral": "Primera Sección", "label": "Ituzaingó", "region": "RMBA" },//6410
    { "value": "132", "seccion_electoral": "Primera Sección", "label": "José C. Paz", "region": "RMBA" },//6412
    { "value": "054", "seccion_electoral": "Cuarta Sección", "label": "Junín", "region": "INTERIOR + 50 MIL HAB." },//6413
    { "value": "123", "seccion_electoral": "Quinta Seccion", "label": "La Costa", "region": "INTERIOR + 50 MIL HAB." },//6420

    { "value": "070", "seccion_electoral": "Tercera Sección", "label": "La Matanza", "region": "RMBA" },//6427
    { "value": "055", "seccion_electoral": "Octava Sección", "label": "La Plata", "region": "RMBA" },//6441
    { "value": "025", "seccion_electoral": "Tercera Sección", "label": "Lanús", "region": "RMBA" },//6434
    { "value": "056", "seccion_electoral": "Sexta Sección", "label": "Laprida", "region": "INTERIOR - 50 MIL HAB." },//6448
    { "value": "058", "seccion_electoral": "Quinta Seccion", "label": "Las Flores", "region": "INTERIOR - 50 MIL HAB." },//6455
    { "value": "059", "seccion_electoral": "Cuarta Sección", "label": "Leandro N. Alem", "region": "INTERIOR - 50 MIL HAB." },//6462
    { "value": "137", "seccion_electoral": "Quinta Seccion", "label": "Lezama", "region": "INTERIOR - 50 MIL HAB." },//6466
    { "value": "060", "seccion_electoral": "Cuarta Sección", "label": "Lincoln", "region": "INTERIOR - 50 MIL HAB." },//6469
    { "value": "061", "seccion_electoral": "Quinta Seccion", "label": "Lobería", "region": "INTERIOR - 50 MIL HAB." },//6476
    { "value": "062", "seccion_electoral": "Tercera Sección", "label": "Lobos", "region": "INTERIOR - 50 MIL HAB." },//6483
    
    { "value": "063", "seccion_electoral": "Tercera Sección", "label": "Lomas de Zamora", "region": "RMBA" },//6490
    { "value": "064", "seccion_electoral": "Primera Sección", "label": "Luján", "region": "RMBA" },//6497
    { "value": "065", "seccion_electoral": "Tercera Sección", "label": "Magdalena", "region": "INTERIOR - 50 MIL HAB." },//6505
    { "value": "066", "seccion_electoral": "Quinta Seccion", "label": "Maipú", "region": "INTERIOR - 50 MIL HAB." },//6511
    { "value": "133", "seccion_electoral": "Primera Sección", "label": "Malvinas Argentinas", "region": "RMBA" },//6515
    { "value": "069", "seccion_electoral": "Quinta Seccion", "label": "Mar Chiquita", "region": "INTERIOR - 50 MIL HAB." },//6518
    { "value": "068", "seccion_electoral": "Primera Sección", "label": "Marcos Paz", "region": "RMBA" },//6525
    { "value": "071", "seccion_electoral": "Primera Sección", "label": "Mercedes", "region": "INTERIOR + 50 MIL HAB." },//6532
    { "value": "072", "seccion_electoral": "Primera Sección", "label": "Merlo", "region": "RMBA" },//6539
    { "value": "073", "seccion_electoral": "Quinta Seccion", "label": "Monte", "region": "INTERIOR - 50 MIL HAB." },//6547

    { "value": "126", "seccion_electoral": "Sexta Sección", "label": "Monte Hermoso", "region": "INTERIOR - 50 MIL HAB." },//6553
    { "value": "074", "seccion_electoral": "Primera Sección", "label": "Moreno", "region": "RMBA" },//6560
    { "value": "101", "seccion_electoral": "Primera Sección", "label": "Morón", "region": "RMBA" },//6568
    { "value": "075", "seccion_electoral": "Primera Sección", "label": "Navarro", "region": "INTERIOR - 50 MIL HAB." },//6574
    { "value": "076", "seccion_electoral": "Quinta Seccion", "label": "Necochea", "region": "INTERIOR + 50 MIL HAB." },//6581
    { "value": "077", "seccion_electoral": "Cuarta Sección", "label": "Nueve de Julio", "region": "INTERIOR + 50 MIL HAB." },//6588
    { "value": "078", "seccion_electoral": "Séptima Sección", "label": "Olavarría", "region": "INTERIOR + 50 MIL HAB." },//6595
    { "value": "079", "seccion_electoral": "Sexta Sección", "label": "Patagones", "region": "INTERIOR - 50 MIL HAB." },//6602
    { "value": "080", "seccion_electoral": "Cuarta Sección", "label": "Pehuajó", "region": "INTERIOR - 50 MIL HAB." },//6609
    { "value": "081", "seccion_electoral": "Sexta Sección", "label": "Pellegrini", "region": "INTERIOR - 50 MIL HAB." },//6616
    
    { "value": "082", "seccion_electoral": "Segunda Sección", "label": "Pergamino", "region": "INTERIOR + 50 MIL HAB." },//6623
    { "value": "083", "seccion_electoral": "Quinta Seccion", "label": "Pila", "region": "INTERIOR - 50 MIL HAB." },//6630
    { "value": "084", "seccion_electoral": "Primera Sección", "label": "Pilar", "region": "RMBA" },//6638
    { "value": "124", "seccion_electoral": "Quinta Seccion", "label": "Pinamar", "region": "INTERIOR - 50 MIL HAB." },//6644
    { "value": "129", "seccion_electoral": "Tercera Sección", "label": "Presidente Perón", "region": "RMBA" },//6648
    { "value": "085", "seccion_electoral": "Sexta Sección", "label": "Puan", "region": "INTERIOR - 50 MIL HAB." },//6651
    { "value": "134", "seccion_electoral": "Tercera Sección", "label": "Punta Indio", "region": "INTERIOR - 50 MIL HAB." },//6655
    { "value": "086", "seccion_electoral": "Tercera Sección", "label": "Quilmes", "region": "RMBA" },//6658
    { "value": "087", "seccion_electoral": "Segunda Sección", "label": "Ramallo", "region": "INTERIOR - 50 MIL HAB." },//6665
    { "value": "088", "seccion_electoral": "Quinta Seccion", "label": "Rauch", "region": "INTERIOR - 50 MIL HAB." },//6672

    { "value": "089", "seccion_electoral": "Cuarta Sección", "label": "Rivadavia", "region": "INTERIOR - 50 MIL HAB." },//6679
    { "value": "090", "seccion_electoral": "Segunda Sección", "label": "Rojas", "region": "INTERIOR - 50 MIL HAB." },//6686
    { "value": "091", "seccion_electoral": "Séptima Sección", "label": "Roque Pérez", "region": "INTERIOR - 50 MIL HAB." },//6693
    { "value": "092", "seccion_electoral": "Sexta Sección", "label": "Saavedra", "region": "INTERIOR - 50 MIL HAB." },//6700
    { "value": "093", "seccion_electoral": "Séptima Sección", "label": "Saladillo", "region": "INTERIOR - 50 MIL HAB." },//6707
    { "value": "122", "seccion_electoral": "Sexta Sección", "label": "Salliqueló", "region": "INTERIOR - 50 MIL HAB." },//6721
    { "value": "067", "seccion_electoral": "Segunda Sección", "label": "Salto", "region": "INTERIOR - 50 MIL HAB." },//6714
    { "value": "094", "seccion_electoral": "Segunda Sección", "label": "San Andrés de Giles", "region": "INTERIOR - 50 MIL HAB." },//6728
    { "value": "095", "seccion_electoral": "Segunda Sección", "label": "San Antonio de Areco", "region": "INTERIOR - 50 MIL HAB." },//6735
    { "value": "116", "seccion_electoral": "Quinta Seccion", "label": "San Cayetano", "region": "INTERIOR - 50 MIL HAB." },//6742

    { "value": "096", "seccion_electoral": "Primera Sección", "label": "San Fernando", "region": "RMBA" },//6749
    { "value": "097", "seccion_electoral": "Primera Sección", "label": "San Isidro", "region": "RMBA" },//6756
    { "value": "131", "seccion_electoral": "Primera Sección", "label": "San Miguel", "region": "RMBA" },//6760
    { "value": "098", "seccion_electoral": "Segunda Sección", "label": "San Nicolás", "region": "INTERIOR + 50 MIL HAB." },//6763
    { "value": "099", "seccion_electoral": "Segunda Sección", "label": "San Pedro", "region": "INTERIOR + 50 MIL HAB." },//6770
    { "value": "100", "seccion_electoral": "Tercera Sección", "label": "San Vicente", "region": "RMBA" },//6778
    { "value": "102", "seccion_electoral": "Primera Sección", "label": "Suipacha", "region": "INTERIOR - 50 MIL HAB." },//6784
    { "value": "103", "seccion_electoral": "Quinta Seccion", "label": "Tandil", "region": "INTERIOR + 50 MIL HAB." },//6791
    { "value": "104", "seccion_electoral": "Séptima Sección", "label": "Tapalqué", "region": "INTERIOR - 50 MIL HAB." },//6798
    { "value": "057", "seccion_electoral": "Primera Sección", "label": "Tigre", "region": "RMBA" },//6805   

    { "value": "105", "seccion_electoral": "Quinta Seccion", "label": "Tordillo", "region": "INTERIOR - 50 MIL HAB." },//6812
    { "value": "106", "seccion_electoral": "Sexta Sección", "label": "Tornquist", "region": "INTERIOR - 50 MIL HAB." },//6819
    { "value": "107", "seccion_electoral": "Cuarta Sección", "label": "Trenque Lauquen", "region": "INTERIOR - 50 MIL HAB." },//6826
    { "value": "108", "seccion_electoral": "Sexta Sección", "label": "Tres Arroyos", "region": "INTERIOR + 50 MIL HAB." },//6833
    { "value": "117", "seccion_electoral": "Primera Sección", "label": "Tres de Febrero", "region": "RMBA" },//6840
    { "value": "127", "seccion_electoral": "Sexta Sección", "label": "Tres Lomas", "region": "INTERIOR - 50 MIL HAB." },//6847
    { "value": "109", "seccion_electoral": "Séptima Sección", "label": "Veinticinco de Mayo", "region": "INTERIOR - 50 MIL HAB." },//6854
    { "value": "110", "seccion_electoral": "Primera Sección", "label": "Vicente López", "region": "RMBA" },//6861
    { "value": "125", "seccion_electoral": "Quinta Seccion", "label": "Villa Gesell", "region": "INTERIOR - 50 MIL HAB." },//6868
    { "value": "111", "seccion_electoral": "Sexta Sección", "label": "Villarino", "region": "INTERIOR - 50 MIL HAB." },//6875
    { "value": "038", "seccion_electoral": "Segunda Sección", "label": "Zárate", "region": "RMBA" },//6882

    //{ "value": "999", "seccion_electoral": "", "label": "CABA", "region": "" },
]

const optionsTipoSubsidio = [
    //{value: "", label: "Seleccionar..."},
    {value: "Subsidio a municipio", label: "Subsidio a municipio"},
    {value: "Subsidio a ONG", label: "Subsidio a ONG"},
    {value: "Otro", label: "Otro"}
]

const optionsOrganismoSolicitante = [
    {value: "Subsidio a municipio", label: "Municipio"},
    {value: "Subsidio a ONG", label: "ONG"},
    {value: "Otro", label: "Otro"}
]

const optionsEncargadoProyecto = [
    //{value: "", label: "Seleccionar..."},
    {value: "Agustín Rocha", label: "Agustín Rocha"},
    {value: "Gustavo Gómez Llera", label: "Gustavo Gómez Llera"},
    {value: "Camila Di Biase", label: "Camila Di Biase"},
    {value: "Matías Gualchi", label: "Matías Gualchi"},
    {value: "Martín La Monica", label: "Martín La Monica"},
    {value: "Eugenia Luna", label: "Eugenia Luna"},
    {value: "Martín Saraqui", label: "Martín Saraqui"},
    {value: "María Estefanía Bernal", label: "María Estefanía Bernal"},
    {value: "María Paula Misson", label: "María Paula Misson"},
    {value: "Cecilia Ferrari", label: "Cecilia Ferrari"},
    {value: "Belén Cortese", label: "Belén Cortese"},
    {value: "Romina Pedernera", label: "Romina Pedernera"},
    {value: "Antonela Dedioniggi", label: "Antonela Dedioniggi"},
    {value: "Valeria Castillo", label: "Valeria Castillo"},
    {value: "Mariana Amigorena", label: "Mariana Amigorena"},
    {value: "Laura Oterino", label: "Laura Oterino"},
    {value: "Camila Godoy", label: "Camila Godoy"},
    {value: "Rocío Cremonte", label: "Rocío Cremonte"},
    {value: "Otro", label: "Otro"}   
]

//cambio de opciones 7-FEB-25
const optionsPrograma = [
    //{value: "", label: "Seleccionar..."},
    {value: "Mejora del Hábitat", label: "Mejora del Hábitat"},
    {value: "Fortalecimiento de Organizaciones de la Comunidad y Municipios para la producción del Hábitat",label: "Fortalecimiento de Organizaciones de la Comunidad y Municipios para la producción del Hábitat"},
    {value: "Programa de Financiación para la capacitación y difusión de la Gestión del hábitat bonaerense",label: "Programa de Financiación para la capacitación y difusión de la Gestión del hábitat bonaerense"},
    {value: "Otro", label: "Otro"}
]

//NUEVO opciones modalidad para Programa 1 y 2
const optionsModalidadUNO = [
    {value: "", label: "Seleccionar..."},
    {value: "Equipamiento de la comunidad", label: "Equipamiento de la comunidad"},
    {value: "Mejoras habitacionales 'Trabajar en Casa'", label: "Mejoras habitacionales 'Trabajar en Casa'"},
    {value: "Infraestructura de redes públicas domiciliarias, intradomiciliarias,etc.", label: "Infraestructura de redes públicas domiciliarias, intradomiciliarias,etc."},
    {value: "Microcréditos", label: "Microcréditos"},
    {value: "Planos de Mensura", label: "Planos de Mensura"}
]

const optionsModalidadDOS = [
    {value: "", label: "Seleccionar..."},
    {value: "Soluciones habitacionales", label: "Soluciones habitacionales"},
    {value: "Herramientas, ropas de trabajo, materiales, equipos, maquinarias y capacitación", label: "Herramientas, ropas de trabajo, materiales, equipos, maquinarias y capacitación"},
    {value: "Servicio de mano de obra", label: "Servicio de mano de obra"}
]

const optionsTipoContratacion= [
    {value: "", label: "Seleccionar..."},
    {value: "Licitación", label: "Licitación"},
    {value: "Administración", label: "Administración"},
    {value: "Mixta", label: "Mixta"}
]

const optionsEstado = [
    //{value: "", label: "Seleccionar..."},
    {value: "Análisis preliminar", label: "Análisis preliminar"},
    {value: "Confección del expediente", label: "Confección del expediente"},
    {value: "En circuito administrativo", label: "En circuito administrativo"},
    {value: "Confección del Convenio", label: "Confección del Convenio"},
    {value: "Resolución", label: "Resolución"},
    {value: "Seguimiento", label: "Seguimiento"},
    {value: "Finalizado", label: "Finalizado"},
    {value: "Observado,  inactivo o suspendido", label: "Observado,  inactivo o suspendido"},
    //{value: "Inactivo o suspendido", label: "Inactivo o suspendido"}, cambio 7-FEB-25
    {value: "En guarda", label: "En guarda"},
    {value: "Otro", label: "Otro"}
]

const optionsTipoProyecto = [
    {value: "", label: "Seleccionar..."},
    {value: "Mejoramiento habitacional", label: "Mejoramiento habitacional"},
    {value: "Mejoramiento habitacional (módulos)", label: "Mejoramiento habitacional (módulos)"},
    {value: "Redes o conexiones internas", label: "Redes o conexiones internas"},
    {value: "Infraestructura barrial", label: "Infraestructura barrial"},
    {value: "Equipamiento comunitario", label: "Equipamiento comunitario"},
    {value: "Planos de mensura", label: "Planos de mensura"},
    {value: "Capacitaciones", label: "Capacitaciones"},
    {value: "Saneamiento urbano", label: "Saneamiento urbano"},
    {value: "Otros", label: "Otros"},
]

const optionsObjetoExpediente = [
    {value: "", label: "Seleccionar..."},
    {value: "Proyecto", label: "Proyecto"},
    {value: "Alcance", label: "Alcance"},
    {value: "Adenda", label: "Adenda"},
    {value: "Rendición", label: "Rendición"},
    {value: "Otro", label: "Otro"}
]

const optionsObjetoExpediente_Mejoras_Microcreditos = [
    {value: "", label: "Seleccionar..."},
    {value: "Proyecto", label: "Proyecto"},
    {value: "Rendición", label: "Rendición"},
    {value: "Adenda", label: "Adenda"}    
]

const optionsObjetoExpediente_Proyectos = [
    {value: "", label: "Seleccionar..."},
    {value: "Proyecto", label: "Proyecto"},
    {value: "Rendición", label: "Rendición"},
    {value: "Adenda", label: "Adenda"}
]

const optionsObjeto_Tramitacion_Pagos = [
    {value: "Rendición", label: "Rendición"},
    {value: "Adenda", label: "Adenda"}
]

//select Documentación presentada (TODO/RESOLUCIÓN/DOCUMENTACIÓN para el pago)
const optionsDocumentacionPresentada = [    
    {value: "Resolución", label: "Resolución"},
    {value: "Documentación para el pago", label: "Documentación para el pago"},
    {value: "Ambas", label: "Ambas"}
]

const optionsEtapaPago = [//Anticipo, 2do_pago, 3er_pago, Total
    {value: "anticipo", label: "Anticipo"},
    {value: "2do_pago", label: "2do pago"},
    {value: "3er_pago", label: "3er pago"},
    {value: "total", label: "Total"}
]

const optionsAvanceObra = [
    {value: "30", label: "30%"},
    {value: "65", label: "65%"},
    {value: "100", label: "100%"}
]    

const optionsIdentificacionCatastral = [
    {value: "", label: "Seleccionar..."},
    {value: "SI", label: "Sí"},
    {value: "NO", label: "No"}
]

const optionsBarrioTipo = [
    {value: "", label: "Seleccionar..."},
    {value: "RPPVAP", label: "Barrio RPPVAP"},
    {value: "OTRO", label: "Otro"}
];

const optionsAreaResponsable = [
    //{value: "", label: "Seleccionar..."},
    {value: "ÁREA DE PROYECTOS", label: "Área de proyectos"},
    {value: "ÁREA DE MEJORAS", label: "Área de mejoras"},
    {value: "ÁREA DE MICROCRÉDITOS", label: "Área de microcréditos"},
    {value: "OTRA", label: "Otra"}
];

const optionsCategoria = [
    //{ value: '', label: 'Seleccionar...' },
    { value: 'social', label: 'Social' },
    { value: 'política', label: 'Política' },
    { value: 'educativa', label: 'Educativa' },
    { value: 'religiosa', label: 'Religiosa' },
    { value: 'deportiva', label: 'Deportiva' },
    { value: 'sindical', label: 'Sindical' }
];

const optionsLPO = [
    {value: "LPO", label: "SI"},
    {value: "NO", label: "NO"}
];

const optionsEncargadoRendicion = [
    //{value: "", label: "Seleccionar..."},
    {value: "AGUSTÍN ROCHA", label: "Agustín Rocha"},
    {value: "GUSTAVO GOMEZ LLERA", label: "Gustavo Gomez Llera"},
    {value: "CAMILA DI BIASE", label: "Camila Di Biase"},
    {value: "MATIAS GUALCHI", label: "Matías Gualchi"},
    {value: "MARTIN LA MONICA", label: "Martín La Monica"},
    {value: "EUGENIA LUNA", label: "Eugenia Luna"},
    {value: "MARTIN SARAQUI", label: "Martín Saraqui"},
    {value: "MARIA ESTEFANIA BERNAL", label: "María Estefanía Bernal"},
    {value: "MARIA PAULA MISSON", label: "María Paula Misson"},
    {value: "CECILIA FERRARI", label: "Cecilia Ferrari"},
    {value: "BELEN CORTESE", label: "Belén Cortese"},
    {value: "ROMINA PEDERNERA", label: "Romina Pedernera"},
    {value: "ANTONELA DEDIONIGGI", label: "Antonela Dedioniggi"},
    {value: "VALERIA CASTILLO", label: "Valeria Castillo"},
    {value: "MARIANA AMIGORENA", label: "Mariana Amigorena"},
    {value: "LAURA OTERIÑO", label: "Laura Oterino"},
    {value: "JAVIER LACHENER", label: "Javier Lachener"},
    {value: "ROBERTO PERITO", label: "Roberto Perito"},
    {value: "ERICA OSTERRIETH", label: "Erica Osterrith"},
    {value: "PAULA KAMERATH", label: "Paula Kamerath"},
    {value: "FACUNDO OVIEDO", label: "Facundo Oviedo"},
    {value: "IGNACIO POLISTINA", label: "Ignacio Polistina"},
    {value: "MIRIAM DENEGRI", label: "Miriam Denegri"},
    {value: "OTRO", label: "Otro"}   
]

const optionsOrganismoEncargado = [
    {value: "", label: "Seleccionar..."},
    {value: "Municipal", label: "Municipal"},
    {value: "Empresa contratista", label: "Empresa contratista"},
    {value: "ONG", label: "ONG"},
    {value: "Otro", label: "Otro"}
]

const optionsEtapaExpediente = [
    {value: "25", label: "Salida convenio - 25%"},
    {value: "50", label: "Firma Convenio - 50%"},
    {value: "75", label: "Salida Resolución - 75%"},
    {value: "100", label: "Firma Resolución - 100%"}
]

// Opciones para tipo de entidad deportiva
const optionsTipoEntidad = [
    { value: 'club', label: 'Club' },
    { value: 'Asociación civil', label: 'Asociación Civil' },
    { value: 'centro_deportivo', label: 'Centro Deportivo' },
    { value: 'sociedad_fomento_actividad_deportiva', label: 'Sociedad de Fomento con Actividad Deportiva' },
    { value: 'otro', label: 'Otro' }
];

export {optionsPartido, optionsTipoSubsidio,
    optionsOrganismoSolicitante,
    optionsEncargadoProyecto, optionsPrograma, optionsModalidadUNO, optionsModalidadDOS,
    optionsTipoContratacion, optionsEstado, optionsTipoProyecto,
    optionsObjetoExpediente,
    optionsObjetoExpediente_Proyectos, optionsObjeto_Tramitacion_Pagos,
    optionsDocumentacionPresentada,
    optionsEtapaPago, optionsAvanceObra,
    optionsObjetoExpediente_Mejoras_Microcreditos,
    optionsIdentificacionCatastral, optionsBarrioTipo,
    optionsAreaResponsable, optionsCategoria, optionsLPO, optionsEncargadoRendicion, optionsOrganismoEncargado, optionsEtapaExpediente,
    optionsTipoEntidad
};
